import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import { REJECT_SCHEMA } from './rejectSchema';
import { RootState } from '../../../store';
import { Button, TextAreaFormik } from '../../Common';
import { useTranslation } from '../../../hooks/useTranslation';

interface RejectLeaveRequestProps {
    id: string;
    rejectLeaveRequest: (id: string, rejectReason: string) => void;
    close: () => void;
}

interface IRejectLeaveRequestValues {
    rejectReason: string;
}

const INITIAL_REQUEST_STATE: IRejectLeaveRequestValues = {
    rejectReason: '',
};

const RejectLeaveRequest = ({ id, rejectLeaveRequest, close }: RejectLeaveRequestProps) => {
    const { t } = useTranslation();
    const content = useSelector((state: RootState) => state.language.data);

    const context = useFormik<IRejectLeaveRequestValues>({
        initialValues: INITIAL_REQUEST_STATE,
        validationSchema: REJECT_SCHEMA(t),
        onSubmit: () => {
            rejectLeaveRequest(id, context.values.rejectReason);
            close();
        },
    });

    return (
        <form className="reject-leave-request" onSubmit={context.handleSubmit}>
            <h3 className="reject-leave-request__header">{content.leaveRequest.rejectionReason}</h3>
            <TextAreaFormik
                id="rejectReason"
                context={context}
                label={content.leaveRequest.rejectionReason}
                placeholder={content.common.addDescription}
                maxLength={250}
            />
            <div className="reject-leave-request__button-wrapper">
                <Button variant="text" text={content.common.cancel} onClick={close} color="blue" />
                <Button text={content.common.submit} isSubmit />
            </div>
        </form>
    );
};

export default RejectLeaveRequest;
